export default {
    //SMS
    SMSBroadcasts: [],
    UserCredits: 0,
    SMSSequences: [],
    SenderIDs: [],    
}